import clsx from 'clsx';
import { endOfDay } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { useParams } from 'react-router-dom';
import { useFilter } from '../../FilterContext';
import { useIntl } from 'react-intl';
import SearchInputGroup from '../../components/SearchInputGroup';
import SingleSelection from '../../components/SingleSelection';
import DatePickerFilter from '../components/DatePickerFilter';
import { ResultStatus } from '../../../../../pages/shuftiPro/mappings';
import MultiSelection from '../../components/MultiSelection';
import { DocumentType } from '../../../../../pages/shuftiPro/documentVerification/mappings';

export function DocumentFilter() {
  const params = useParams();
  const intl = useIntl();
  const { globalFilter, setGlobalFilter } = useFilter();
  const filterKey = 'documentEnquiries';

  const documentTypeOptions = [
    {
      value: DocumentType.PASSPORT,
      label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.DOCUMENT_TYPE_OPTIONS.PASSPORT' }),
    },
    {
      value: DocumentType.ID_CARD,
      label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.DOCUMENT_TYPE_OPTIONS.ID_CARD' }),
    },
    {
      value: DocumentType.DRIVING_LICENSE,
      label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.DOCUMENT_TYPE_OPTIONS.DRIVING_LICENSE' }),
    },
    {
      value: DocumentType.CREDIT_DEBIT_CARD,
      label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.DOCUMENT_TYPE_OPTIONS.CREDIT_DEBIT_CARD' }),
    },
  ];

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        <div className='d-inline-flex flex-wrap'>
          {/* Select */}
          <div className='d-flex'>
            {/* Date Picker */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    enquiry_date: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              globalFilterValue={
                globalFilter?.[filterKey]?.enquiry_date?.from &&
                globalFilter?.[filterKey]?.enquiry_date?.to && {
                  startDate: new Date(globalFilter?.[filterKey]?.enquiry_date?.from),
                  endDate: new Date(globalFilter?.[filterKey]?.enquiry_date?.to),
                }
              }
              label={intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.REQUEST_DATE' })}
              placeholder={intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.FILTER_REQUEST_DATE' })}
              className='me-6'
            />

            {/* Type */}
            <MultiSelection
              title={intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.DOCUMENT_TYPE' })}
              globalFilterValue={
                globalFilter?.[filterKey]?.['enquiry_data.supported_types']?.values
              }
              options={documentTypeOptions}
              className='w-225px'
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    'enquiry_data.supported_types': { type: 'in', values: e },
                  },
                });
              }}
            />

            {/* Result Status */}
            <SingleSelection
              title={intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.RESULT_STATUS' })}
              globalFilterValue={globalFilter?.[filterKey]?.['enquiry_result_event']?.values}
              options={[
                {
                  value: ResultStatus.ACCEPTED,
                  label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.STATUS_OPTIONS.ACCEPTED' }),
                },
                {
                  value: ResultStatus.DECLINED,
                  label: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.STATUS_OPTIONS.DECLINED' }),
                },
              ]}
              isClearable
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  [filterKey]: {
                    ...globalFilter?.[filterKey],
                    enquiry_result_event: e?.value ? { type: 'in', values: [e] } : undefined,
                  },
                });
              }}
              className='min-w-175px'
            />
          </div>

          {/* Search */}
          <SearchInputGroup
            inputs={[
              {
                key: 'result.reference',
                title: intl.formatMessage({ id: 'SHUFTI.ENQUIRIES.REFERENCE_ID' }),
              },
              {
                key: 'merchant_id',
                title: intl.formatMessage({ id: 'CLIENTS.CLIENT_ID' }),
                minWidth: 200,
              },
            ]}
            section={filterKey}
            globalFilterValue={globalFilter}
            onSubmit={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
              })
            }
            onClear={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                [filterKey]: { ...globalFilter?.[filterKey], ...searchValues },
              })
            }
          />
        </div>
      </div>
    </>
  );
}
